// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".designer-iframe-wrapper{background:#333 url(https://s3.amazonaws.com/snappykraken/assets/website/img/document-loading.png) 50%;background-repeat:no-repeat;background-size:20%}", ""]);
// Exports
module.exports = exports;
